import { request, METHOD } from '@/utils/request'
import { BASE_URL } from '@/config/public'

export async function rqtGetBuilding(params) {
  return request(
    `${BASE_URL}/provider/ams/building/listBuilding`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostBuildingQuery(params) {
  return request(
    `${BASE_URL}/provider/ams/building/query`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostBuildingQueryCount(params) {
  return request(
    `${BASE_URL}/provider/ams/building/query/count`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostBuilding(params) {
  return request(
    `${BASE_URL}/provider/ams/building`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtGetBuildingEditor(params) {
  return request(
    `${BASE_URL}/provider/ams/building/${params}`,
    METHOD.GET,
    params
  )
}

export async function rqtPutBuilding(params) {
  return request(
    `${BASE_URL}/provider/ams/building`,
    METHOD.PUT_JSON_ENCRYPT,
    params
  )
}

export async function rqtDeleteBuilding(params) {
  return request(
    `${BASE_URL}/provider/ams/building/${params}`,
    METHOD.DELETE_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostBuildingAuditAgree(params) {
  return request(
    `${BASE_URL}/provider/ams/building/${params.id}/audit/agree`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostBuildingAuditReject(params) {
  return request(
    `${BASE_URL}/provider/ams/building/${params.id}/audit/reject`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}
